import React from 'react';
import Dragger from "antd/es/upload/Dragger";
import {InboxOutlined} from "@ant-design/icons";
import {message} from "antd";
import {API_BASE_URL} from "../constants";

const Uploader = ({onExifInfo}) => {

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });

    const onChange = async (info) => {
        const {status} = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
            const imgBase64 = await getBase64(info.file.originFileObj);
            onExifInfo({...info.file.response, imgBase64, imgType: info.file.type})
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }

    const onDrop = (e) => {
        console.log('Dropped files', e.dataTransfer.files);
    }

    return (<Dragger name={'file'}
                     maxCount={1}
                     onChange={onChange}
                     onDrop={onDrop}
                     action={`${API_BASE_URL}/exif/upload`}>
        <p className="ant-upload-drag-icon">
            <InboxOutlined/>
        </p>
        <p className="ant-upload-text">Click or drag file to this area to upload</p>
    </Dragger>);
}

export default Uploader;


// WEBPACK FOOTER //
// ./src/uploader/Uploader.js